import { testimonials } from "@/mocks/manga";

export default function Feedback() {
  return (
    <section id="feedback" className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-4 py-1.5 text-sm font-medium text-primary-500">
            <i className="ri-chat-heart-line"></i>
            读者口碑
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            万千读者的一致好评
          </h2>
          <p className="mt-3 max-w-xl text-base text-foreground-700">
            真实读者的追更故事，就是奇妙漫画最好的证明。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="rounded-xl border border-background-200/70 bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-primary-500">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-accent-500 to-primary-500 font-heading text-sm font-bold text-background-50">
                  {t.avatar}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-600">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}